module.exports = __webpack_public_path__ + "img/longate-bonus-bg-mobile.c35bca81.jpg";